var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "noLive-msg" }, [
    _c("div", { staticClass: "msg-content" }, [
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.isFlashBettingTab
              ? _vm.$t("FlashBetting.NoAvailableFlashLiveEvents")
              : _vm.$t("Sports.NoAvailableLiveEvents")
          )
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b39a97ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39a97ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/live/noLiveMsg.vue
// module id = null
// module chunks = 